import { Component, OnInit, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AuthService } from '@shared/auth/auth.service'; 
import { VoucherService } from 'app/services/voucher-service';
import { ITreatmentViewModel } from 'app/models/household/treatment';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { MatTableDataSource } from '@angular/material/table';
import { SampleViewModel } from 'app/models/well/samples/sample.viewmodel';
/*
 * Link Treatment Dialog
 */

@Component({
    selector: 'dialog-link-treatment',
    templateUrl: 'link-treatment-dialog.html',
    styleUrls: ['./link-treatment-dialog.scss']
  })
  export class DialogLinkTreatmentComponent implements OnInit  { 
    loading: boolean = false;
    processing: boolean = false;
    selectedId: number = 0;
    @Input('voucherId')
    voucherId: string = "";
    @Input('treatementId')
    treatmentId: number = 0;
    treatmentPlans: ITreatmentViewModel[] = [];
    displayedColumnsTreatmentPlans: string[] = ['select','treatmentId','statusOfInstall','installedBy','treatmentInstallCompletionDate','latestFilterChangeDate'];
    dataSourceTreatmentPlans = new MatTableDataSource<ITreatmentViewModel>(this.treatmentPlans);

    samples: SampleViewModel[] = [];
    displayedColumnsSamples: string[] = ['select','sampleId','createDate','collectionDate','retOrNot','isSampleReTest','postTreatment', 'treatmentId'];
    dataSourceSamples = new MatTableDataSource<SampleViewModel>(this.samples);

    constructor(
      public authService: AuthService,
      public oregonWellDataService: OregonWellDataService,
      private toastr: ToastrService,
      private voucherService: VoucherService,
      @Inject(MAT_DIALOG_DATA) public data: number[], 
      private dialogRef: MatDialogRef<DialogLinkTreatmentComponent>) {
        this.voucherId = this.data['voucherId'];
        this.treatmentId = this.data['treatmentId'];
    } 
   
    ngOnInit(): void {  
      if(this.voucherId.length <= 0 && this.treatmentId <= 0) {
        this.toastr.error('Invalid Id.  Cannot link treatment/sample.');
        this.dialogRef.close();
      }  
      else if(this.voucherId.length > 0) {
        this.getTreatmentPlans();
      } 
      else if(this.data['treatmentId'] > 0) {
        this.getSamples();
      } 
      else {
        this.toastr.error('Invalid Id.  Cannot link treatment/sample.');
        this.dialogRef.close();
      }
    }

    approveLink() {
      this.dialogRef.close(this.selectedId);
    }

    onChangeSelectedTreatment(treatmentId: number) {
      this.selectedId = treatmentId;
    }

    onChangeSelectedSample(sampleId: number) {
      this.selectedId = sampleId;
    }

    getSamples() {
      this.loading = true;
      this.voucherService.getSamplesByTreatementId(this.treatmentId).subscribe(result => {
        this.samples = result;
        this.dataSourceSamples = new MatTableDataSource<SampleViewModel>(this.samples);
        this.loading = false;
      },
      error => {
        this.oregonWellDataService.showToastError("Error occured looking up Samples");
        this.loading = false;
      });
    }

    getTreatmentPlans() {
        let voucherIds = [this.voucherId];
        this.loading = true;
        this.voucherService.getTreatmentPlansByVoucherIds(voucherIds).subscribe(result => {
          this.treatmentPlans = result;
          this.dataSourceTreatmentPlans = new MatTableDataSource<ITreatmentViewModel>(this.treatmentPlans);
          this.loading = false;
        },
        error => {
          this.oregonWellDataService.showToastError("Error occured looking up Treatment Plans");
          this.loading = false;
        });
      }
  }